// Shared formatters — every list/detail/export site goes through these so
// dates, currencies, and percentages render consistently.

const EMDASH = '—';

export function fmtDateTime(value: unknown): string {
  if (value === null || value === undefined || value === '') return EMDASH;
  const d = value instanceof Date ? value : new Date(String(value));
  if (Number.isNaN(d.getTime())) return EMDASH;
  return d.toLocaleString();
}

export function fmtDate(value: unknown): string {
  if (value === null || value === undefined || value === '') return EMDASH;
  // A bare "YYYY-MM-DD" (a DateOnly, e.g. a gaming day) has NO timezone — it is
  // a calendar label, not an instant. `new Date("2026-08-08")` parses it as UTC
  // midnight, which toLocaleDateString then shifts a day earlier in any behind-
  // UTC zone. Format the calendar parts directly so the label is preserved.
  if (typeof value === 'string') {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).toLocaleDateString();
  }
  const d = value instanceof Date ? value : new Date(String(value));
  if (Number.isNaN(d.getTime())) return EMDASH;
  return d.toLocaleDateString();
}

/** Currency values stored in integer cents → display in major units. */
export function fmtCurrencyCents(cents: unknown, currency = 'USD'): string {
  if (cents === null || cents === undefined || cents === '') return EMDASH;
  const n = Number(cents);
  if (Number.isNaN(n)) return EMDASH;
  try {
    return (n / 100).toLocaleString(undefined, { style: 'currency', currency });
  } catch {
    return `${(n / 100).toFixed(2)} ${currency}`;
  }
}

/** Stored value IS the percent (e.g. 1.5 → 1.50%). Don't multiply by 100. */
export function fmtPercent(value: unknown): string {
  if (value === null || value === undefined || value === '') return EMDASH;
  const n = Number(value);
  if (Number.isNaN(n)) return EMDASH;
  return `${n.toFixed(2)}%`;
}

export function fmtBool(value: unknown, trueLabel = 'Yes', falseLabel = 'No'): string {
  if (value === null || value === undefined || value === '') return EMDASH;
  return value ? trueLabel : falseLabel;
}

export function fmtOrEmDash(value: unknown): string {
  if (value === null || value === undefined || value === '') return EMDASH;
  return String(value);
}
